export default "__VITE_ASSET__DCPG55cu__"